import { FAQCategoriesContainerDefault } from './styledComponent'

export default function FAQCategoryContainerWrapper({ layoutType, children }) {
  switch (layoutType) {
    default:
      return <FAQCategoriesContainerDefault>{children}</FAQCategoriesContainerDefault>
  }
}
